import { render, staticRenderFns } from "./AppDataTableTopSearch.vue?vue&type=template&id=536ba154&scoped=true&"
import script from "./AppDataTableTopSearch.vue?vue&type=script&lang=js&"
export * from "./AppDataTableTopSearch.vue?vue&type=script&lang=js&"
import style0 from "./AppDataTableTopSearch.vue?vue&type=style&index=0&id=536ba154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ba154",
  null
  
)

export default component.exports